module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__customer-group",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "label": "Название",
      "name": "name",
      "id": "name",
      "required": true,
      "error": _vm.errors.first('name'),
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    attrs: {
      "label": "Символьный код",
      "name": "code",
      "id": "code",
      "required": true,
      "error": _vm.errors.first('code'),
      "data-vv-name": "code",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.group.code),
      callback: function($$v) {
        _vm.$set(_vm.group, "code", $$v)
      },
      expression: "group.code"
    }
  }), _vm._v(" "), _c('z-text-area', {
    attrs: {
      "disabled": _vm.sending,
      "name": "description",
      "id": "description",
      "label": "Описание",
      "error": _vm.errors.first('description'),
      "data-vv-name": "description",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.group.description),
      callback: function($$v) {
        _vm.$set(_vm.group, "description", $$v)
      },
      expression: "group.description"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-293bcec5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/views/Group.vue
// module id = 1082
// module chunks = 0